// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"85":"3588a39f","123":"c45eda7d"}[chunkId] + ".chunk.css";
};